module.exports = __webpack_public_path__ + "static/media/sidebar-fww-01.709036ed.jpg";